import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import { columnDescription, columnName } from '@/constants/fields';
import ActionDialogContent from '@/components/dialogs/ActionDialogContent';
import TableWrapper from '@/components/table/TableWrapper';
import { states } from '@/constants/lifecycle';
import { deleteUserGroup, hideDeleteUserGroupDialog } from '../actions/usergroups/delete';
import UserGroupsTableColumns from './UserGroupsTableColumns';
import UserGroupsTableRows from '../components/UserGroupsTableRows';

const DeleteUserGroupDialog = ({
  hide,
  onDelete,
  results,
  theme,
}) => (
  <ActionDialogContent
    className="aridhia-usergroup-deletion-dialog"
    inProgress={results.some((result) => result.destroyStatus === states.PENDING)}
    entities="usergroups"
    entity="usergroup"
    hide={hide}
    icon="users"
    items={results}
    onSubmit={onDelete}
    theme={theme}
  >
    <div className="aridhia-dialog-table-container">
      <TableWrapper sticky celled className="aridhia-usergroups-table">
        <Table.Header fullWidth>
          <UserGroupsTableColumns items={results} columns={[columnName, columnDescription]} />
        </Table.Header>
        <Table.Body>
          <UserGroupsTableRows items={results} columns={[columnName, columnDescription]} />
        </Table.Body>
      </TableWrapper>
    </div>
  </ActionDialogContent>
);

const mapStateToProps = ({
  userGroups: { userGroups: { deletion: { results } } },
}) => ({ results });

const mapDispatchToProps = {
  onDelete: deleteUserGroup,
  hide: hideDeleteUserGroupDialog,
};

export default connect(mapStateToProps, mapDispatchToProps)(DeleteUserGroupDialog);
